// 定义内容
export default {
	introTitleUIE: 'YAYI-UIE accurate',
	introTitleExtrac: ' knowledge extraction ',
	introTitleAI: 'AI assistant',
	introTitleMain: 'Based on millions of Chinese and English data, combined with supervised fine-tuning and human intention alignment, it performs well in the field of information extraction, supporting complex scene information extraction in public opinion, media publicity, finance, security and other fields.',
	enterkeyword: 'Type keywords',
	enterDetail: 'enter',
	extractInfor: 'Extract information',
	extractContent: 'Extract content',
	extractResults: 'Extraction result',
	copyJSON: 'Copy JSON',
	extractionProgress: 'Extracting',
	sendExtractedView: 'Check on the left after sending the extraction content',
	record: 'Chats',
	historyRecord: 'Historical record',
	confirmDeletSession: 'Confirm to delete this session',
	confirm: 'Confirm',
	cancel: 'Cancel',
	submit: 'Submit',
	nohistory: 'No historical records',
	feedbackMeansLot: 'Your feedback is of great significance to us, and we hope you can fill in your opinion',
	moreDesAnswer: 'What surprises have I brought you?',
	abnormalNetwork: 'The current network is abnormal, check the network',
	copySuccessful: 'The replication is successful',
	likeSuccess: 'Like success',
	tapSuccess: 'The tap is successful',
	hisNameNoEmpty: 'The history name cannot be empty'
};
